import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EditableProcedureData } from "../../../../types/editableTreatmentPlan";
import SurfaceSelectionSelect from "../../../../components/SurfaceSelectionSelect";
import { TreatmentStepEditChips } from "../TreatmentStepChips";
import { EditAddCodeButtonWrapper } from "./EditTreatmentAppointment.styled";

export interface EditProcedureSurfaceFieldProps {
  appointmentId: number;
  procedureIndex: number;
  procedure: EditableProcedureData;
  onChange: (surfaces: string[]) => void;
}

const EditProcedureSurfaceField: React.FC<EditProcedureSurfaceFieldProps> = ({
  appointmentId,
  procedureIndex,
  procedure,
  onChange,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasCdtCode = procedure.resolvedCdtCodes.length > 0;

  const handleRemove = (value: string) => {
    onChange(procedure.surfaces.filter((surface) => surface !== value));
  };

  return (
    <EditAddCodeButtonWrapper>
      <TreatmentStepEditChips
        values={procedure.surfaces}
        onRemove={handleRemove}
        onAddClick={() => setOpen(true)}
        disabled={!hasCdtCode}
        disabledReason={t("treatmentPlan.selectCdtCodeFirst")}
      />
      <SurfaceSelectionSelect
        hideTrigger
        open={open && hasCdtCode}
        onOpenChange={(nextOpen) => {
          if (!hasCdtCode) {
            setOpen(false);
            return;
          }
          setOpen(nextOpen);
        }}
        name={`surface-${appointmentId}-${procedureIndex}`}
        value={procedure.surfaces}
        onChange={onChange}
      />
    </EditAddCodeButtonWrapper>
  );
};

export default EditProcedureSurfaceField;
